import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import "../userDashboard.css";
import UserTransactionsWrapper from "../../../components/userProfileComp/UserTransactionsListWrapper";

export const UserTransactionPages = () => {
  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar
          showBackButton
          displayType="title"
          title="Transactions"
          showNotification
        ></TopBar>
        <UserTransactionsWrapper></UserTransactionsWrapper>
        <Tabbar menuType={"users"}></Tabbar>
      </div>
    </>
  );
};

export default UserTransactionPages;
